import React from "react";
import OperationButton from "./operation-panel-button/operation-button.jsx";
import { getQuery, sliceObject } from "../../lib/xes/xes-lib";
import XesSaverHoc from "../../lib/xes/xes-saver-hoc.jsx";
import {connect} from 'react-redux';
import "./panel.css";
import bindAll from 'lodash.bindall';
import Modal from "antd/lib/modal";
import TagForm from "../../components/tag-form/tag-form.jsx";
import {setProjectTitle} from '../../reducers/project-title';
import message from "antd/lib/message/index";
import localStore from '../../lib/xes/local-store'
import mblock from '../../lib/mblock-sdk'
import Button from 'antd/lib/button'
import Save, { toggleSaveLoading } from './operation-panel-button/save'

const isTemplate = getQuery('isTemplate') === 'true'
const tagCacheKey = 'scratch-configure-tag'
class ConfigureTopic extends React.Component {
  constructor(props) {
    super(props)
    this.tag = undefined
    this.workData = undefined
    this.initDefaultTag = false
    bindAll(this, [
      'handleSave',
      'handleSaveAs',
      'provideProjectInfoToTagSetting',
      'closeModal',
      'openModal',
      'handleConfirmSave',
      'updateTags',
      'setWorkData',
      'isWorkNew',
      'updateDefaultTagAfterLoaded',
      'toggleSaveLoading',
      'toggleSaveAsLoading'
    ])
    this.action = undefined
    this.state = {
      modalVisible: false,
      defaultTag: {
        name: '',
        semester: 1,
        term: 1,
        level: 2,
        lesson: 1,
        purpose: 1,
        pro_type: 1,
        topic: 1,
        tag: ''
      },
      hasTagForm: false,
      saveLoading: false,
      saveAsLoading: false,
      saveLabel: '保存',
      saveAsLabel: '另存为'
    }
  }
  componentDidUpdate(preProps) {
    if (this.props === preProps) {
      return
    }
    if (this.tag === undefined) {
      this.tag = this.workData
    }
    if ( this.props.xesProjectMeta && this.props.xesProjectMeta.teacher_work && !this.initDefaultTag) {
      this.updateDefaultTagAfterLoaded()
      this.initDefaultTag = true
    }
  }
  toggleSaveLoading (loading) {
    this.setState({
      saveLoading: loading,
      saveLabel: loading ? '保存中' : '保存'
    })
  }
  toggleSaveAsLoading (loading) {
    this.setState({
      saveAsLoading: loading,
      saveAsLabel: loading ? '另保存中' : '另保存'
    })
  }
  openModal() {
    this.setState({
      modalVisible: true,
      hasTagForm: true
    })
  }
  closeModal() {
    this.setState({
      modalVisible: false,
      hasTagForm: false
    })
  }
  updateTags(newTag) {
    this.tag = newTag
    localStore.store(tagCacheKey, newTag)
  }
  provideProjectInfoToTagSetting(data) {
    window.provideProjectInfoToTagSetting = () => {
      if (data.teacher_work) {
        data.teacher_work.project_type = "project"
      } else {
        data.teacher_work = {
          project_type: "project"
        }
      }
      data.version = '3.0'
      return data
    }
  }
  setWorkData (data) {
    this.workData = data
  }
  handleConfirmSave() {
    let params
    let isNew = true
    if (!this.tag) {
      this.tag = this.state.defaultTag
    }
    if (this.action === 'beforeSave') {
      if (this.tag.name) {
        this.props.onUpdateReduxProjectTitle(this.tag.name)
      }
      isNew = false
      params = { ...this.tag }
      toggleSaveLoading(true)
    } else if (this.action === 'beforeSaveAs') {
      isNew = false
      params = { ...this.tag, ...{name: this.props.projectTitle} }
    } else if (this.action === 'saveAs') {
      this.toggleSaveAsLoading(true)
      params = Object.assign({}, this.workData, this.tag)
    }
    this.closeModal()
    return this.props.saveConfigureProject(params, isNew).then((data) => {
      // message.success('', 1)
      this.toggleSaveAsLoading(false)
      this.closeModal()
      return data
    })
  }
  handleSave() {
    this.action = 'beforeSave'
    if (this.isWorkNew()) {
      if (localStore.get(tagCacheKey)) {
        this.setState({
          defaultTag: Object.assign({}, localStore.get(tagCacheKey), {name: this.props.projectTitle}) 
        })
      }
    } else {
      this.setState({
        defaultTag: Object.assign({}, this.state.defaultTag, {name: this.props.projectTitle})
      })
    }
    this.openModal()
  }
  handleSaveAs() {
    this.action = 'beforeSaveAs'
    this.handleConfirmSave().then((data) => {
      this.setWorkData(data)
      this.action = 'saveAs'
      this.setState({
        defaultTag: Object.assign({}, this.state.defaultTag, {name: this.props.projectTitle})
      })
      this.openModal()
    })
  }
  updateDefaultTagAfterLoaded() {
    this.props.xesProjectMeta.teacher_work.name = this.props.xesProjectMeta.name
    this.setState({
      defaultTag: sliceObject(['name', 'semester', 'term', 'level', 'lesson', 'purpose', 'pro_type', 'topic', 'tag'], this.props.xesProjectMeta.teacher_work)
    })
  }
  render() {
    return (
      <div className="panel">
        {!isTemplate && (
          <Save onClick={this.handleConfirmSave}>{this.state.saveLabel}</Save>
        )}
        {/* {!isTemplate && (
          <Button
            className="xes-button"
            onClick={this.handleSaveAs}
            loading={this.state.saveAsLoading}
          >
            {this.state.saveAsLabel}
          </Button>
        )} */}

        {isTemplate && <div>模板无法修改</div>}
        <Modal
          title="添加标签"
          cancelText="取消"
          okText="确定"
          visible={this.state.modalVisible}
          onOk={this.handleConfirmSave}
          onCancel={this.closeModal}
        >
          {this.state.hasTagForm ? (
            <TagForm
              updateTags={this.updateTags}
              defaultTag={this.state.defaultTag}
            />
          ) : null}
        </Modal>
      </div>
    );
  }
  isWorkNew() {
    return this.props.xesProjectMeta.category == 2
  }
}

const mapStateToProps = state => ({
    getCode: mblock.getCode,
    projectTitle: state.scratchGui.projectTitle,
    xesProjectMeta: state.scratchGui.xesProjectState.xesProjectMeta
});

const mapDispatchToProps = dispatch => ({
    onUpdateReduxProjectTitle: title => {
        dispatch(setProjectTitle(title))
    }
});


export default XesSaverHoc(
  connect(
      mapStateToProps,
      mapDispatchToProps
  )(ConfigureTopic)
)
